const DEFAULT_FROM_ROUTE = {
  name: null,
  path: '',
  query: {},
  params: {},
  meta: {},
  fullPath: '',
};

export default {
  state: () => ({
    name: null,
    path: '',
    query: {},
    params: {},
    meta: {},
    fullPath: '',
    from: {},
  }),
  actions: {
    updateRoute({ commit }, payload) {
      commit('updateRoute', payload);
    },
  },
  mutations: {
    updateRoute(state, { to = {}, from = {} } = {}) {
      const normalizedTo = to && typeof to === 'object' ? to : {};
      const normalizedFrom = from && typeof from === 'object' ? from : {};

      state.name = normalizedTo.name ?? null;
      state.path = normalizedTo.path ?? '';
      state.query = normalizedTo.query ?? {};
      state.params = normalizedTo.params ?? {};
      state.meta = normalizedTo.meta ?? {};
      state.fullPath = normalizedTo.fullPath ?? '';
      state.from = {
        ...DEFAULT_FROM_ROUTE,
        ...normalizedFrom,
      };
    },
  },
};
